import { resetInferentialStatistics } from 'store/form/inferentialStatistics';

import {
  SET_PARAMETERS_INFERENTIAL_STATISTICS,
  RESET_PARAMETERS_INFERENTIAL_STATISTICS,
  SET_HAS_NUMERICAL_VARIABLES_EMPTY_CELL,
  SET_HAS_CATEGORICAL_VARIABLES_EMPTY_CELL
} from './types';

import {
  getNumericalSummary,
  getCategoricalSummary,
  getFilteredParameterValues,
  getVisibleNumericalSelectedParametersNames,
  getVisibleCategoricalSelectedParametersNames
} from 'store/dataset';

import isEmpty from 'lodash/isEmpty';

export const setParametersInferentialStatistics = values => ({
  type: SET_PARAMETERS_INFERENTIAL_STATISTICS,
  values
});

export const resetParametersInferentialStatistics = () => ({
  type: RESET_PARAMETERS_INFERENTIAL_STATISTICS
});

export const resetParametersInferentialStatisticsPage = () => dispatch => {
  return dispatch([
    resetInferentialStatistics(),
    resetParametersInferentialStatistics()
  ]);
};

export const setHasNumericalVariablesEmptyCell = () => (dispatch, getState) => {
  const state = getState();

  const numericalSummary = getNumericalSummary(state);
  let hasNumericalVariablesEmptyCell = false;

  if (!isEmpty(numericalSummary)) {
    const numericalSelectedParametersNames = getVisibleNumericalSelectedParametersNames(state);

    if (numericalSelectedParametersNames.length > 0) {
      hasNumericalVariablesEmptyCell = numericalSelectedParametersNames.some(numericalParameter => {
        const parameter = numericalSummary[numericalParameter].name;
        const row = getFilteredParameterValues(state, parameter);
        return row.includes('') || row.includes('empty');
      });
    }
  }
  dispatch({ type: SET_HAS_NUMERICAL_VARIABLES_EMPTY_CELL, hasNumericalVariablesEmptyCell });
};

export const setHasCategoricalVariablesEmptyCell = () => (dispatch, getState) => {
  const state = getState();

  const categoricalSummary = getCategoricalSummary(state);
  let hasCategoricalVariablesEmptyCell = false;

  if (!isEmpty(categoricalSummary)) {
    const categoricalSelectedParametersNames = getVisibleCategoricalSelectedParametersNames(state);

    if (categoricalSelectedParametersNames.length > 0) {
      hasCategoricalVariablesEmptyCell = categoricalSelectedParametersNames.some(categoricalParameter => {
        const parameter = categoricalSummary[categoricalParameter].name;
        const row = getFilteredParameterValues(state, parameter);
        return row.includes('') || row.includes('empty');
      });
    }
  }

  dispatch({ type: SET_HAS_CATEGORICAL_VARIABLES_EMPTY_CELL, hasCategoricalVariablesEmptyCell });
};
